import React, { useEffect, Fragment } from "react";
import { useForm } from "react-hook-form";

import classnames from "classnames";
import ReportInput from "../v2/ReportInput";

const ReportForm2ndPartV3 = ({
  gameId,
  onSubmitReport,  
  products,
  donateOption,
}) => {
  const {
    register,
    handleSubmit,
    errors,  
    setError,
    clearErrors,
    watch,
    setValue,
  } = useForm(); // initialise the hook
  const watchInvoiceOption = watch("invoiceOption", "donate"); // you can supply default value as second argument
  const watchQty = watch("qty"); // you can supply default value as second argument
  const watchProductId = watch("productId"); // you can supply default value as second argument
  
  const watchEventCheck = watch("eventCheck"); // you can supply default value as second argument

  // console.log("products", products);
  // console.log("watchProductId", watchProductId);
  
  let H73Event = false;
  const H73EventBegin = new Date("2025-09-30 12:00:00");
  const H73EventEnd = new Date("2025-10-31 23:59:59");
  const today = new Date();
  if (gameId === "H73" && today.getTime() >= H73EventBegin.getTime() && today.getTime() <= H73EventEnd.getTime()) {
      H73Event = true;
  }

  useEffect(() => {
    if (watchProductId !== undefined) {
      const product = products.filter(
        (p) => p.product_id === watchProductId
      )[0];

      if (product) {
        if (gameId === "g66naxx2tw" && watchQty !== "1") {
          setValue("qty", 1);
        }
        if (gameId === "G112" && watchQty !== "1") {
          setValue("qty", 1);
        }
        if (gameId === "L33" && watchQty !== "1") {
          setValue("qty", 1);
        }
        if (gameId === "H73" && watchQty !== "1") {
          setValue("qty", 1);
        }
        if (gameId === "MA96" && watchQty !== "1") {
          setValue("qty", 1);
        }
        setValue("wireAmount", watchQty * product.price);
      }
    }
  }, [watchQty, watchProductId, gameId, products, setValue]);

  //console.log("errors", errors);
  const onSubmit = (data) => {
    
    if (watchInvoiceOption === "donate" && data.loveCode === "") {
      setError("loveCode", {
        type: "manual",
        message: "請選擇捐贈單位",
      });
      return;
    }

    if (watchInvoiceOption === "mobile") {
      if (data.carrierNum === "") {
        setError("carrierNum", {
          type: "manual",
          message: "請輸入條碼",
        });
        return;
      } else {
        let re = /^\/[A-Z0-9+-.]{7}$/;
        let chk = re.test(data.carrierNum);
        if (!chk) {
          setError("carrierNum", {
            type: "manual",
            message: "條碼格式錯誤",
          });
          return;
        }
      }
    }

    if (watchInvoiceOption === "citizen") {
      if (data.carrierNum === "") {
        setError("carrierNum", {
          type: "manual",
          message: "請輸入條碼",
        });
        return;
      } else {
        let re = /^[A-Z]{2}[0-9]{14}$/;
        let chk = re.test(data.carrierNum);
        if (!chk) {
          setError("carrierNum", {
            type: "manual",
            message: "條碼格式錯誤",
          });
          return;
        }
      }
    }

    if (watchInvoiceOption === "paper" && data.recipient === "") {
      setError("recipient", {
        type: "manual",
        message: "請輸入收件人姓名",
      });
      return;
    }

    if (watchInvoiceOption === "paper" && data.address === "") {
      setError("address", {
        type: "manual",
        message: "請輸入發票寄送地址",
      });
      return;
    }

    if (watchEventCheck === "1" && data.eventRecipient === "" && H73Event) {
      setError("eventRecipient", {
        type: "manual",
        message: "請輸入活動收件人姓名",
      });
      return;
    }

    if (watchEventCheck === "1" && data.eventAddress === "" && H73Event) {
      setError("eventAddress", {
        type: "manual",
        message: "請輸入活動收件地址",
      });
      return;
    }

    if (watchEventCheck === "1" && data.eventPhone === "" && H73Event) {
      setError("eventPhone", {
        type: "manual",
        message: "請輸入活動收件人連絡電話",
      });
      return;
    }

    let addInfo =
      watchInvoiceOption !== "paper" ? { area: "", address: "" } : { area: "" };

    if (watchEventCheck === "1" && H73Event) {
      addInfo = { ...addInfo, eventArea: "" };
    }

    //console.log({ ...data, report_type: '2', ...addInfo })
    onSubmitReport({ ...data, report_type: '2', ...addInfo });
  };

  return (
    <form className="card border-info mb-3" onSubmit={handleSubmit(onSubmit)}>
      <div className="card-header  border-info">第二步: 選擇購買品項</div>
      <div className="card-body text-info">
        <ReportInput
          type="select"
          name="productId"
          label="方案"
          symbol="🎁"
          register={register({
            required: "請選擇購買方案",
          })}
          error={errors.productId}
          options={[
            { label: "請選擇購買方案", value: "" },
            ...products.map((option) => ({
              label: option.title + " - " + option.product_desc,
              value: option.product_id,
            })),
          ]}
        />
        <ReportInput
          type="number"
          name="qty"
          label="數量"
          symbol="#️⃣"
          register={register({
            required: "輸入數量",
            min: { value: 1, message: "至少要一個阿" },
            max: {
              value: gameId === "g66naxx2tw" || gameId === "G112" || gameId === "L33" || gameId === "H73" || gameId === "MA96" ? 1 : 10,
              message: "不要超過太多阿",
            },
          })}
          error={errors.qty}
        />
        
        <ReportInput
          type="number"
          name="wireAmount"
          label="金額"
          symbol="💲"
          register={register({
            required: "輸入金額",
            min: 3000,
          })}
          readonly={watchProductId ? true : false}
          error={errors.wireAmount}
        />

        <div className="form-group">
          <label htmlFor="invoice" className="col-form-label-sm">
            發票選項(一律開立二聯式發票)
          </label>

          <div className="form-group">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                defaultChecked={true}
                name="invoiceOption"
                ref={register}
                value="donate"
              />
              <label className="form-check-label" htmlFor="invoiceDonate">
                捐贈發票
              </label>

              {watchInvoiceOption === "donate" && (
                <Fragment>
                <select
                  name="loveCode"
                  ref={register}
                  className={classnames("form-control form-control-md", {
                    "is-invalid": errors.loveCode,
                  })}
                  onChange={() => clearErrors("loveCode")}
                >
                  <option value="">請選擇捐贈單位</option>
                  {Object.keys(donateOption).map((key) => (
                    <option key={key} value={key}>
                      {donateOption[key]}
                    </option>
                  ))}
                </select>  

                {errors.loveCode && (
                  <div className="invalid-feedback">
                    {errors.loveCode?.message}
                  </div>
                )}
                </Fragment>          
              )}
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="invoiceOption"
                ref={register}
                value="ezpay"
              />
              <label className="form-check-label" htmlFor="invoiceEzpay">
                ezPay 電子發票載具
              </label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="invoiceOption"
                ref={register}
                value="mobile"
              />
              <label className="form-check-label" htmlFor="invoiceMobile">
                手機條碼載具
              </label>

              {watchInvoiceOption === "mobile" && (
                <Fragment>
                <input
                  className={classnames("form-control form-control-md mb-2", {
                    "is-invalid": errors.carrierNum,
                  })}
                  type="text"
                  placeholder="手機條碼"
                  name="carrierNum"
                  ref={register}
                  maxLength="8"
                />

                {errors.carrierNum && (
                  <div className="invalid-feedback">
                    {errors.carrierNum?.message}
                  </div>
                )}
                </Fragment>
              )}
            </div>
            {/*
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="invoiceOption"
                ref={register}
                value="citizen"
              />
              <label className="form-check-label" htmlFor="invoiceCitizen">
                自然人憑證條碼載具
              </label>

              {watchInvoiceOption === "citizen" && (
                <Fragment>
                <input
                  className={classnames("form-control form-control-md mb-2", {
                    "is-invalid": errors.carrierNum,
                  })}
                  type="text"
                  placeholder="自然人憑證條碼"
                  name="carrierNum"
                  ref={register}
                  maxLength="16"
                />

                {errors.carrierNum && (
                  <div className="invalid-feedback">
                    {errors.carrierNum?.message}
                  </div>
                )}
                </Fragment>
              )}
            </div>
            */}
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="invoiceOption"
                ref={register}
                value="paper"
              />
              <label className="form-check-label" htmlFor="invoicePaper">
                紙本發票
              </label>

              {watchInvoiceOption === "paper" && (
                <Fragment>
                  <input
                    className={classnames("form-control form-control-md mb-2", {
                      "is-invalid": errors.recipient,
                    })}
                    type="text"
                    placeholder="收件人姓名"
                    name="recipient"
                    ref={register}
                    maxLength="10"
                  />

                  {errors.recipient && (
                    <div className="invalid-feedback">
                      {errors.recipient?.message}
                    </div>
                  )}

                  <input
                    name="address"
                    className={classnames("form-control form-control-md", {
                      "is-invalid": errors.address,
                    })}
                    type="text"
                    placeholder="發票寄送地址"
                    ref={register}
                  />

                  {errors.address && (
                    <div className="invalid-feedback">
                      {errors.address?.message}
                    </div>
                  )}
                  <small className="text-danger d-block">
                    註：我們會在開獎日後幫您對獎，若有中獎便會以掛號寄出紙本發票，讓您可至財政部指定兌領機構兌領獎金。若未中獎則該紙本將予以銷毀。
                  </small>
                </Fragment>
              )}
            </div>
          </div>

          {H73Event && (
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                name="eventCheck"
                ref={register}
                value="1"
              />
              <label className="form-check-label" htmlFor="eventCheck">
                若有贈獎活動時，我願意參加(選填)
              </label>

              {watchEventCheck === "1" && (
                <Fragment>
                  <input
                    className={classnames("form-control form-control-md mb-2", {
                      "is-invalid": errors.eventRecipient,
                    })}
                    type="text"
                    placeholder="活動收件人姓名"
                    name="eventRecipient"
                    ref={register}
                    maxLength="10"
                  />

                  {errors.eventRecipient && (
                    <div className="invalid-feedback">
                      {errors.eventRecipient?.message}
                    </div>
                  )}

                  <input
                    name="eventAddress"
                    className={classnames("form-control form-control-md mb-2", {
                      "is-invalid": errors.eventAddress,
                    })}
                    type="text"
                    placeholder="活動收件地址"
                    ref={register}
                  />

                  {errors.eventAddress && (
                    <div className="invalid-feedback">
                      {errors.eventAddress?.message}
                    </div>
                  )}

                  <input
                    name="eventPhone"
                    className={classnames("form-control form-control-md mb-2", {
                      "is-invalid": errors.eventPhone,
                    })}
                    type="text"
                    placeholder="活動收件人連絡電話"
                    ref={register}
                    maxLength="20"
                  />

                  {errors.eventPhone && (
                    <div className="invalid-feedback">
                      {errors.eventPhone?.message}
                    </div>
                  )}
                </Fragment>
              )}
            </div>
          )}
          <button type="submit" className="btn btn-primary float-right">
            送出
          </button>
        </div>
      </div>
    </form>
  );
};

export default ReportForm2ndPartV3;
